import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import type { NodeCfg } from '../nodes';

export const resetVariablesNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('resetVariables'),
    controlValues: z.object({
        varIds: z.array(z.string()),
    }),
});
export type ResetVariablesNodeCfgSchema = z.infer<typeof resetVariablesNodeCfgSchema>;

export const resetVariablesNodeSocketCfg = {
    controlSockets: {
        outputs: () => ({ next: 'event' }),
        inputs: () => ({ trigger: 'event' }),
    },
    dataSockets: {
        inputs: (_cfg: NodeCfg<'resetVariables'>) => ({}),
        outputs: (_cfg: NodeCfg<'resetVariables'>) => ({}),
    },
} satisfies NodeSocketCfg<ResetVariablesNodeCfgSchema>;
